export default __webpack_public_path__ + "media/images/loading-pricing-8244cf385ad60100a1cb42c15e19a85a.svg";